'use strict'

import { mapActions, mapState } from 'vuex'
import * as types from '@/store/types.js'
import { eventBus } from '@/app/event-bus.js'

export default {
  computed: {
    ...mapState({
      timeout: state => state.timer.timeout,
      lastActionTime: state => state.timer.lastActionTime,
      currentTime: state => state.timer.currentTime
    }),
    timerOver () {
      if (this.timeout !== 0) {
        return (this.currentTime - this.lastActionTime) > this.timeout
      }
      return false
    }
  },
  data () {
      return {
        timerIntervalId: null
      }
  },
  methods: {
    ...mapActions({
      currentTimeUpdate: types.TIMER.currentTime.update,
      lastActionTimeUpdate: types.TIMER.lastActionTime.update
    }),
    runTimer () {
      this.timerIntervalId = setInterval(() => {
        this.currentTimeUpdate()
        if (this.timerOver) {
          this.lastActionTimeUpdate()
          eventBus.emitCancelModule()
        }
      }, 1000)
    },
    isElapsedTimer (seconds) {
      return (this.currentTime - this.lastActionTime > seconds)
    }
  },
  mounted () {
    this.runTimer()
  },
  beforeDestroy () {
    clearInterval(this.timerIntervalId)
  }
}
